import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17c4335a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "hero-slider" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" swe "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" web development "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" claude agent swarm coordinator "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" working at a telecom company with a couple million users ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contact-row" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "email-link letter",
    href: "mailto:hi@artyom.io?subject=a%20humble%20request"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "email"),
    /*#__PURE__*/_createElementVNode("svg", {
      class: "ext-icon",
      viewBox: "0 0 24 24",
      width: "12",
      height: "12",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M7 17 17 7" }),
      /*#__PURE__*/_createElementVNode("path", { d: "M8 7h9v9" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    class: "email-link letter",
    href: "https://discord.com/users/240850877433380865",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "discord"),
    /*#__PURE__*/_createElementVNode("svg", {
      class: "ext-icon",
      viewBox: "0 0 24 24",
      width: "12",
      height: "12",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M7 17 17 7" }),
      /*#__PURE__*/_createElementVNode("path", { d: "M8 7h9v9" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    class: "email-link",
    href: "https://github.com/artyom-sklyarov/dots",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "dots"),
    /*#__PURE__*/_createElementVNode("svg", {
      class: "ext-icon",
      viewBox: "0 0 24 24",
      width: "12",
      height: "12",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M7 17 17 7" }),
      /*#__PURE__*/_createElementVNode("path", { d: "M8 7h9v9" })
    ])
  ])
], -1))
const _hoisted_6 = {
  key: 0,
  class: "writeups"
}
const _hoisted_7 = { class: "writeups-header" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "writeups-title" }, "POSTS", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("read all posts →")
const _hoisted_10 = { class: "writeup-title" }
const _hoisted_11 = { class: "writeup-date" }

import { onMounted, onBeforeUnmount, ref } from 'vue';
    import ViewContainer from '../components/ViewContainer.vue';
    import { articles } from '../blog/articles';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

    const slides = ['/image.webp', '/slide-2.webp', '/image-2.webp', '/image-3.webp', '/pudge.webp'];
    const index = ref(0);
    let timer: number | undefined;

    onMounted(() => {
        timer = window.setInterval(() => {
            index.value = (index.value + 1) % slides.length;
        }, 3000);
    });
    onBeforeUnmount(() => {
        if (timer) clearInterval(timer);
    });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(ViewContainer, null, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(slides, (src, i) => {
            return _createElementVNode("img", {
              key: src,
              src: src,
              class: _normalizeClass(['hero-img', { active: i === index.value }]),
              alt: ""
            }, null, 10, _hoisted_3)
          }), 64))
        ]),
        _hoisted_4,
        _hoisted_5
      ]),
      (_unref(articles).length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_router_link, {
                class: "writeups-all",
                to: "/posts"
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(articles).slice(0, 2), (a) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: a.slug,
                to: `/posts/${a.slug}`,
                class: "writeup"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(a.title), 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(a.date), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})